import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import LoaderIcon from "../Common/Icon/Loader";
import AgreementDetailPopUpComponent from "./AgreementDetailPopUpComponent";

const AgreementComponent = ({isActive, customerId, agreementList}) => {
    const { t } = useTranslation();
    const [showDetailPopUp, setShowDetailPopUp] = useState(false);
    const [isFormLoader, setIsFormLoader] = useState(false);
    const [agreementData, setAgreementData] = useState(false);

    const handleModalCloseDataFromChild = () => {
        setShowDetailPopUp(false);
    };
    const handleShowDetail = (value) => {
        setShowDetailPopUp(true);
        setAgreementData(value);
    };

    return (
        <div className="relative">
            <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-2 sm:gap-4 bg-white sm:bg-transparent rounded-xl sm:rounded-none p-2 sm:p-0">
                <NavLink to={(isActive ? `/profiles/create-agreement/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed") + " rounded-xl border-gray-normal border border-dashed hidden sm:flex flex-col justify-center items-center min-h-20"}>
                    <div className="flex items-center space-x-2">
                        <img className="w-8 h-8" src="../../assets/icons/profile/plus.svg" alt="plus" />
                        <div className="font-medium capitalize">{ t("enrol to new agreement")}</div>
                    </div>
                </NavLink>
                {(agreementList.length > 0) ?
                    agreementList.map((agreement, index) => (
                        <div key={`agreement${index}`}>
                            <div className="sm:rounded-xl sm:bg-white flex justify-between items-center sm:p-4 cursor-pointer" onClick={(e) => handleShowDetail(agreement)}>
                                <div className="flex space-x-2 w-full">
                                    <div className="bg-blue-light rounded-xl p-2 flex flex-col justify-between items-center h-fit">
                                        <img className="w-6 h-6 sm:w-8 sm:h-8" src="../../assets/icons/profile/file1.svg" alt="file" />
                                    </div>
                                    <div className="w-full space-y-1">
                                        <div className="flex justify-between w-full">
                                            <h1 className="font-semibold text-xs sm:text-base capitalize">{agreement.Contract_Title}</h1>
                                            <div className="cursor-pointer px-1 pb-1">
                                                <img src="../../assets/icons/profile/arrow-right.svg" alt="arrow-right" />
                                            </div>
                                        </div>
                                        <div className="flex justify-between items-center w-full">
                                            <div className="capitalize text-[10px] sm:text-xs">
                                                { t('valid from')} {moment(agreement.Start_Date, "DD/MM/YYYY").format('ll')} - {moment(agreement.End_Date, "DD/MM/YYYY").format('ll')}
                                            </div>
                                            <div className={`${{Pending: "bg-yellow-normal1", Accepted: "bg-green-normal", Rejected: "bg-red-normal"}[agreement.Is_Approved] || "bg-gray-500"} capitalize text-white p-1 rounded-md text-[10px] sm:text-xs`}>
                                                {agreement.Is_Approved}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(agreementList.length !== (index+1)) ? <div className="my-1 border-t border-dashed border-background-normal block sm:hidden"></div> : null}
                        </div>
                    ))
                :
                    <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white block sm:hidden">
                        { t('no data available')}
                    </div>
                }
            </div>
            {/* create button for mobile screen */}
            <div className="fixed bottom-2 sm:hidden w-screen left-0 px-4">
                <NavLink to={(isActive ? `/profiles/create-agreement/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed")}>
                    <div className="rounded-lg  p-2 text-white bg-blue-normal font-medium text-center capitalize">
                        + { t("enrol to new agreement")}
                    </div>
                </NavLink>
            </div>
            {/* modal */}
            {showDetailPopUp &&
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="absolute sm:relative bottom-0 sm:bottom-auto sm:inline-block align-center bg-white rounded-t-xl sm:rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle max-w-lg sm:max-w-xl w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            {isFormLoader
                                ?
                                    <LoaderIcon />
                                :
                                <AgreementDetailPopUpComponent sendModalCloseDataFromChild={handleModalCloseDataFromChild} agreementData={agreementData} />
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default AgreementComponent;